export default __webpack_public_path__ + "static/media/person_3@2x.5223bcd9.png";